
export const navList = [
  { path: '/home', name: '首页' },
  {
    path: 'production',
    name: '产品介绍',
    type: 1,
    children: [
      { path: '/production/ssLive', name: '双师课' },
      { path: '/production/ai', name: 'AI课' },
      { path: '/production/content', name: '未来好课' },
      { path: '/production/libu', name: '励步' },
      { path: '/production/accomplishment', name: '素养课' },
      { path: '/production/weclassroom', name: '直播云' }
    ] 
  },
  { path: '/success-info', name: '成功案例' },
  { path: '/download', name: '下载中心' },
  { path: 'about_us', name: '关于我们', type: 2, children: [{ path: '/about_us', name: '关于我们', subTitle: '全球优质科技教育产品供应平台' }, { path: '/about_us/news_center/list', name: '媒体报道', subTitle: '未来魔法校最新动态' }] }
]
export const footerNavList = {
  left: [
    { path: '',
      name: '产品介绍',
      type: 1,
      children: [
        { path: '/production/ssLive', name: '双师课' },
        { path: '/production/ai', name: 'AI课' },
        { path: '/production/content', name: '未来好课' },
        { path: '/production/libu', name: '励步' },
        { path: '/production/accomplishment', name: '素养课' },
        { path: '/production/weclassroom', name: '直播云' }
      ]
    }
  ],
  right: [
    { path: '', name: '成功案例', children: [{ path: '/success-info', name: '成功案例', subTitle: '' }] },
  { path: '', name: '关于我们', type: 2, children: [{ path: '/about_us', name: '关于我们' }, { path: '/about_us/news_center/list', name: '媒体报道' }] }
  ]
}
export const coreAbilityData = [
  {
      isImg: true,
      imgUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-1-1.png'
  },
  {
      isImg: false,
      title: '教研积累',
      mes: '好未来18年教研资源与数据沉淀<br>百万真题库与教学视频在线支持<br>千人教研团队助力内容快速升级'
  },
  {
      isImg: false,
      title: '科技投入',
      mes: '与 6 所全球知名大学等建立联合<br>实验室<br>投入超 12亿元/年 用于科技研发<br>组建超 5000人  技术研发团队'
  },
  {
      isImg: true,
      imgUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-1-2.png'
  },
  {
      isImg: true,
      imgUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-1-3.png'
  },
  {
      isImg: false,
      title: '优质教师',
      mes: '魔法校专业讲师<br>6轮选拔，平均授课时长超5000小时<br>单次讲课10小时以上备课磨课，5次<br>以上试讲'
  }
]
export const cooperationDemo = [
  {
    type_name: '中小型机构',
    list: [
      {
        img: '',
        school_name: '武汉优杰教育机构',
        school_des: '“通过未来好课完善的学科内容体系，强大的教研支持，提升了机构自有教研体系的竞争力，帮助我们机构实现进一步发展。”',
        president: '— 武汉优杰教育校长',
        coop_date: '2019-10',
        coop_type: '未来好课'
      },
      {
        img: '',
        school_name: '韩城放飞梦想培训中心',
        school_des: '“未来好课的课程体系，完整的运营服务支持以及智能课堂服务系统，让我们的数学教学团队快速成长起来，稳定实现数学扩科。”',
        president: '— 韩城放飞梦想培训中心校长',
        coop_date: '2019-05',
        coop_type: '未来好课'
      },
      {
        img: '',
        school_name: '福州市起点培训中心',
        school_des: '“未来好课标准的备课流程、高效的教学方法和完整的备授课服务体系，整体提升了我们的教学质量，帮助年轻老师快速成长。”',
        president: '— 福州起点培训中心校长',
        coop_date: '2019-05',
        coop_type: '未来好课'
      },
      {
        img: '',
        school_name: '保定拓普教育',
        school_des: '“我感觉自己就是好未来人，从合作的第一天起，好未来对我们就像直营校一样毫无保留地全力扶持。”',
        president: '— 保定拓普教育高校长',
        coop_date: '2020-03',
        coop_type: '未来好课'
      }
    ]
  },
  {
    type_name: '大型机构',
    list: [
      {
        img: '',
        school_name: '平舆麦田',
        school_des: '“希望一款能够满足中国孩子英语学习需求的产品能够帮助更多孩子走上科学的英语学习之路！”',
        president: '— 校长寄语',
        coop_date: '2019-03',
        coop_type: '乐外教英语'
      },
      {
        img: '',
        school_name: '河南爱上课',
        school_des: '“紧跟行业标杆，提升综合能力，成就更多学生”',
        president: '— 校长寄语',
        coop_date: '2019-01',
        coop_type: '双师+乐外教英语'
      }
    ]
  }
]
export const methodScrollConfig = {
  navList: [
    {
      main: '6',
      sub: '大教学模式'
    },
    {
      main: '7',
      sub: '步备课法'
    },
    {
      main: '8',
      sub: '步教学法'
    }
  ],
  imgList: [
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cotent-scroll-1.png',
      width: 933,
      height: 258
    },
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cotent-scroll-2.png',
      width: 888,
      height: 485
    },
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cotent-scroll-3.png',
      width: 824,
      height: 477
    }
  ],
  sectionHeight: [0, 520, 1040],
  boxHeight: 520,
  id: 'methods-wrapper'
}
export const serviceScrollConfig = {
  navList: [
    {
      main: '3',
      sub: '大运营支持'
    },
    {
      main: '4',
      sub: '大服务系统'
    },
    {
      main: '5',
      sub: '大教学场景'
    }
  ],
  imgList: [
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cotent-scroll-4.png',
      width: 775,
      height: 297
    },
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cotent-scroll-5.png',
      width: 772,
      height: 581
    },
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cotent-scroll-6.png',
      width: 797,
      height: 358
    }
  ],
  sectionHeight: [0, 581, 1162],
  boxHeight: 581,
  id: 'service-wrapper'
}

export const ssLittleTeacherTeam = {
  main: '主讲团队',
  sub: '将优质教育资源共享给更多的孩子',
  teacherUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-teacher.png',
  title: '主讲团队',
  type_name: '双师小组课',
  des: '魔法校主讲老师领衔主讲团队，严苛录取；<br>他们扎实的专业知识，先进的教育理念，成就对学生教育知识的传承'
}
export const ssLiveTeacherTeam = {
  main: '主讲团队',
  sub: '将优质教育资源共享给更多的孩子',
  teacherUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-teacher.png',
  title: '主讲团队',
  type_name: '双师课',
  des: '魔法校主讲老师领衔主讲团队，严苛录取；<br>他们扎实的专业知识，先进的教育理念，成就对学生教育知识的传承'
}
export const cloudList = [
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cloud-1.png',
    main: '课中互动系统',
    sub: '集成多种趣味互动形式，利用“互动系统+答题器”打造沉浸式课堂。'
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cloud-2.png',
    main: '教务管理系统',
    sub: '助力机构日常管理，提供班级创建、学员管理、教师管理、校区管理等功能。'
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cloud-3.png',
    main: '学生端',
    sub: '贯穿学习各个阶段，包括预习、课前测、课上学习、笔记、课后练、课后复习等，定期生成学习报告，实现学习过程透明化、学习效果可视化。'
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cloud-4.png',
    main: '辅导端',
    sub: '支持客观题系统自动批改、主观题在线批改及在线备课功能，在线查看学生学习数据，提供针对性教学服务，协助老师日常工作。'
  }
]
export const supportLittleList = {
  main: '辅导老师教室内全程伴学',
  sub: '让每个孩子都能受到关注',
  list: [
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-1-1.png',
      main: '双师直播间',
      des: '教师授课，与机构共享优质教学资源'
    },
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-1-2.png',
      main: '智慧教室',
      des: '辅导老师全程伴学，答疑解惑'
    },
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-1-3.png',
      main: '学生线上学习',
      des: '学生随时随地在线上课'
    }
  ]
}
export const supportAiList = {
  main: '优选外教动态授课，与学生高频互动',
  sub: '教学生动有趣，开班周期灵活，机构可随时开班上课',
  list: [
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-1-1.png',
      main: '优选外教授课',
      des: ''
    },
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-1-2.png',
      main: '课堂高频互动效果好',
      des: ''
    },
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-1-3.png',
      main: '随时开班、周期灵活',
      des: ''
    }
  ]
}
export const supportLiveList = {
  main: '辅导老师教室内全程伴学',
  sub: '让每个孩子都能受到关注',
  list: [
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-1-1.png',
      main: '双师直播间',
      des: '教师授课，与机构共享优质教学资源'
    },
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-1-2.png',
      main: '智慧教室',
      des: '辅导老师全程伴学，答疑解惑'
    }
  ]
}
export const learnList = [
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/student-1.png',
    main: '办学无场地限制',
    des: '主讲和辅导老师课中与学生高频互动，让孩子学习更加高效'
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/student-2.png',
    main: '辅导老师在线伴学',
    des: '让每个学生都被关注'
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/student-3.png',
    main: '课中互动至少10分钟1次',
    des: '让学生上课更有参与感'
  }
]
export const littleOperateList = {
  main: '让每个孩子的学习更有参与感',
  sub: '辅导老师课中关注每个孩子的学习情况',
  list: [
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-little-2-1.png',
      main: '办学无场地限制',
      des: '主讲和辅导老师课中与学生高频互动，让孩子学习更加高效'
    },
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-little-2-2.png',
      main: '辅导老师在线伴学',
      des: '让每个学生都被关注'
    },
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-little-2-3.png',
      main: '课中互动至少10分钟1次',
      des: '让学生上课更有参与感'
    }
  ]
}
export const liveOperateList = {
  main: '机构运作全链条运营支持',
  sub: '打通所有教学场景的数据，帮助老师掌握孩子学习情况',
  list: [
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-5-1.png',
      main: '爆品课引流',
      des: '大IP爆品课物料支持，帮助机构解决招生难题'
    },
    {
      url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-5-2.png',
      main: '机构老师培训',
      des: '未来魔法校助力机构健康成长'
    }
  ]
}
export const learnAiList = [
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/ai-4-1.png',
    main: '真实教学场景',
    des: ''
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/ai-4-2.png',
    main: '课中超过高频开口互动',
    des: ''
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/ai-4-3.png',
    main: '运用趣味动画，引入流行IP',
    des: ''
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/ai-4-4.png',
    main: 'AI智能判断学生学习状态',
    des: ''
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/ai-4-5.png',
    main: '课后阅读可听可练可读可玩',
    des: ''
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/ai-4-6.png',
    main: '让孩子真正爱上学习',
    des: ''
  }
]
export const achieveList = [
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-4-4.png',
    des: '科技部批准依托好未来建设智慧教育国家新一代人工智能开放创新平台'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-4-1.png',
    des: '斯坦福大学-好未来联合项目签约仪式'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-4-2.png',
    des: '好未来与北京师范大学等6所高校专家启动联合项目'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-4-3.png',
    des: '2019年9月，未来魔法校和剑桥大学出版社达成战略合作'
  }
]
// export const productSolutionList = [
//   {
//     type_id: 1,
//     type_name: '双师直播',
//     type_des: '魔法校老师授课，解决机构招老师难问题，助力扩展学科',
//     bg_img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-3-1.png'
//   },
//   {
//     type_id: 2,
//     type_name: '双师小组课',
//     type_des: '魔法校老师授课，学生在家上课，助力解决疫情期间复课问题',
//     bg_img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-3-2.png'
//   },
//   {
//     type_id: 3,
//     type_name: 'AI课',
//     type_des: '优选外教授课，可随时开课，让招生不再受困于老师班期',
//     bg_img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-3-3.png'
//   },
//   {
//     type_id: 4,
//     type_name: '未来好课',
//     type_des: '18年教研数据沉淀，千人教研团队持续支持，帮助机构提升教学质量',
//     bg_img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-3-4.png'
//   }
// ]
export const productSolutionList = [
  {
    type_id: 2,
    bg: '#08BCFF',
    type_name: '双师课',
    type_des: '魔法校老师授课，解决机构招老师难问题，助力扩展学科',
  },
  {
    type_id: 4,
    bg: '#706CFF',
    type_name: 'AI课',
    type_des: '优选外教授课，可随时开课，让招生不再受困于老师班期',
  },
  {
    type_id: 1,
    bg: '#8C69F0',
    type_name: '未来好课',
    type_des: '18年教研数据沉淀，千人教研团队持续支持，帮助机构提升教学质量',
  },
  {
    type_id: 3,
    bg: '#FD6C5F',
    type_name: '励步',
    type_des: '以培养语言、跨学科应用能力和素养为目标，提供完整学习解决方案',
  },
  {
    type_id: 5,
    bg: '#FD995F',
    type_name: '素养课',
    type_des: '阅读、STEAM、数独、美术、写字……多种素养课程，全面助力学校',
  },
  {
    type_id: 0,
    bg: '#0186FF',
    type_name: '直播云',
    type_des: '专注教育场景，以在线授课为中心，构建线上线下相融合的专业在线课堂',
  }
]
export const solutionList = [
  {
    type_name: '招生提升',
    list: [
      {
        index: '01',
        name: '学员招生',
        children: [
          {
            id: 1,
            name: '品牌支持',
            des: '主讲团队的包装，产品宣传物料和魔法校的品牌背书',
            isPortrait: true,
            imgs: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-2-1-1.png'
          },
          {
            id: 2,
            name: '物料支持',
            des: '招生+宣传海报，课程内容+题库资料',
            isPortrait: true,
            imgs: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-2-1-2.png'
          },
          {
            id: 3,
            name: '运营工具支持',
            des: '学员测评+海报自定义工具+打卡签到助手',
            isPortrait: true,
            imgs: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-2-1-3.png'
          },
          {
            id: 4,
            name: '招生支持',
            des: '爆品招生课+招生培训，活动方案+伴跑活动',
            isPortrait: true,
            imgs: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-2-1-4.png'
          }
        ]
      },
      {
        index: '02',
        name: '学员上课',
        children: [
          {
            id: 5,
            name: '魔法校课堂',
            des: '共享一线教育资源',
            isPortrait: false,
            imgs: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-2-2-1.png'
          },
          {
            id: 6,
            name: '专业教研',
            des: '18年深厚沉淀',
            isPortrait: false,
            imgs: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-2-2-2.png'
          },
          {
            id: 7,
            name: 'AI课',
            des: '把前沿科技融入教学',
            isPortrait: false,
            imgs: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-2-2-3.png'
          }
        ]
      }
    ]
  },
  {
    type_name: '续费提升',
    list: [
      {
        index: '03',
        name: '课后+家校沟通',
        children: [
          {
            id: 8,
            name: '功课自动批改',
            des: '解放老师课后精力，实现更多带班',
            isPortrait: false,
            imgs: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-2-3-1.png'
          },
          {
            id: 9,
            name: '学员学习报告',
            des: '更多维度解读孩子学情状况',
            isPortrait: false,
            imgs: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-2-3-2.png'
          }
        ]
      },
      {
        index: '04',
        name: '续费周期运营',
        children: [
          {
            id: 10,
            name: '校长培训学院+三板斧',
            des: '未来魔法校陪着校长们一起成长',
            isPortrait: true,
            imgs: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-2-4-1.png'
          },
          {
            id: 11,
            name: '机构老师培训',
            des: '解决机构招老师难的问题',
            isPortrait: false,
            imgs: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-2-4-2.png'
          },
          {
            id: 12,
            name: '教学质量监控',
            des: '课中+课后学员学习情况监测，帮助机构在续费周期前介入维护关怀',
            isPortrait: false,
            imgs: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/home-2-4-3.png'
          }
        ]
      }
    ]
  }
]
export const ssLiveCompare = {
  main: '双师模式对比传统面授的优势',
  sub: '更优质的授课内容，更稳定的授课团队，更有趣的授课方式',
  list: [
    {
      title: '师资设备',
      bad: '传统面授',
      good: '双师课堂',
      bad_mes: '本地老师授课',
      good_mes: '北京老师主讲、本地老师辅导'
    },
    {
      title: '主讲背景',
      bad: '传统面授',
      good: '双师课堂',
      bad_mes: '普通背景',
      good_mes: '魔法校培训，多年授课经验'
    },
    {
      title: '主讲稳定性',
      bad: '传统面授',
      good: '双师课堂',
      bad_mes: '不稳定、易流失',
      good_mes: '稳定性强'
    },
    {
      title: '教研能力',
      bad: '传统面授',
      good: '双师课堂',
      bad_mes: '参差不齐',
      good_mes: '标准化'
    },
    {
      title: '课后服务',
      bad: '传统面授',
      good: '双师课堂',
      bad_mes: '难兼顾',
      good_mes: '辅导老师专职负责'
    },
    {
      title: '课堂互动',
      bad: '传统面授',
      good: '双师课堂',
      bad_mes: '形式单一、传统',
      good_mes: '趣味多样'
    },
    {
      title: '办学成本',
      bad: '传统面授',
      good: '双师课堂',
      bad_mes: '主讲老师高分成',
      good_mes: '固定课时费'
    }
  ]
}
export const ssLittleCompare = {
  main: '双师小组课对比大班网课的优势',
  sub: '主讲老师高频互动，辅导老师全程线上伴学，学生上在线课更有参与感',
  list: [
    {
      title: '主讲老师',
      bad: '大班网课',
      good: '双师小组课',
      bad_mes: '纯输出内容，与学生无交流',
      good_mes: '至少10分钟1次课程相关<span style="color: #FE5945;">内容互动</span>'
    },
    {
      title: '辅导老师',
      bad: '大班网课',
      good: '双师小组课',
      bad_mes: '无辅导老师',
      good_mes: '<span style="color: #FE5945;">在线伴学，</span>关注每个学生学习情况'
    },
    {
      title: '课后服务',
      bad: '大班网课',
      good: '双师小组课',
      bad_mes: '难兼顾',
      good_mes: '辅导老师根据学生课堂学习数据，课后进行<span style="color: #FE5945;">定制化辅导</span>'
    }
  ]
}
export const equipmentDetail = [
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-2-1.png',
    des: '不同类型的AI课'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-2-2.png',
    des: '骨骼点检测'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-2-3.png',
    des: '表情识别'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-2-4.png',
    des: '丰富的双师课程'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-2-5.png',
    des: '手势识别'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-2-6.png',
    des: '语音识别'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-2-7.png',
    des: '海量内容的教研云'
  }
]
export const ssLearn = [
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-3-1.png',
    title: '课中互动系统',
    des: '集成多种趣味互动形式，利用“互动系统+答题”打造沉浸式课堂。'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-3-2.png',
    title: '教务管理系统',
    des: '助力机构日常管理，提供班级创建、学员管理、教师管理、校区管理等功能。'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-3-3.png',
    title: '学生端',
    des: '贯穿学习各个阶段，包括预习、课前测、课上学习、笔记、课后练、课后复习等，定期生成学习报告，实现学习过程透明化、学习效果可视化。'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-3-4.png',
    title: '辅导端',
    des: '支持客观题系统自动批改、主观题在线批改及在线备课功能，在线查看学生学习数据，提供针对性教学服务，协助老师日常工作。'
  }
]
export const contentLearn = [
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/content-4-1.png',
    title: '备授课系统',
    des: '提供教师备课标准流程和资料，帮助教师快速掌握授课思路，课前模拟授课。提供课中互动工具，帮助教师组织课堂，让课堂更生动。'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/content-4-2.png',
    title: '教务管理系统',
    des: '提供教师管理、班级创建、学员报名、调课、转班和退费等业务办理功能，支持查看运营数据分析，让办学更加便捷。'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/content-4-3.png',
    title: '学生端',
    des: '提供课前预习、加油站、错题本、延伸阅读等关键功能，定期为学生生成学习报告，实现学习过程透明化，学习效果可视化。'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/content-4-4.png',
    title: '辅导端',
    des: '支持客观题系统自动批改、主观题在线批改及在线备课功能，支持在线查看学生学习数据，提供针对性教学服务，提升机构服务能力。'
  }
]
export const subjectList = [
  {
    id: 1,
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-4-1.png',
    name: '语文'
  },
  {
    id: 2,
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-4-2.png',
    name: '数学'
  },
  {
    id: 3,
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-4-3.png',
    name: '英语'
  },
  {
    id: 4,
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-4-4.png',
    name: '物理'
  },
  {
    id: 5,
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-4-5.png',
    name: '化学'
  }
]
export const ssLiveBanner = {
  bg: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-bg.png',
  videlUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/ms_ssLive-all.mp4',
  type_name: '双师课',
  type_des: '魔法校老师授课，机构老师在教室指导学生课中学习+课后家辅'
}

export const accomplishmentBanmer = {
  bg: require('@/assets/coursetype/suyang/banner.png'),
  type_name: '素养课',
  type_des: '多种素养课程，全面助力学校'
}
export const ssLittleBanner = {
  bg: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-little-bg.png',
  videlUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/ms_little-all.mov',
  type_name: '双师小组课',
  type_des: '魔法校老师授课，机构学生随时随地在线上课，机构辅导老师通过摄像头和数据关注学生学习情况，全程伴学'
}
export const aiBanner = {
  bg: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-bg.png',
  videlUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/AI-all.mp4',
  type_name: 'AI课',
  type_des: '将AI技术融入到教学场景中，通过人脸识别、动作识别以及答题器的数据反馈，把控授课难度与进度，实现因材施教'
}

export const weclassroomBanner = {
  bg: require('@/assets/coursetype/zhiboyun/banner.png'),
  videlUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/weclassroom-all.mp4',
  type_name: '直播云',
  type_des: '专注打造多场景直播服务平台'
}

export const libuBanner = {
  bg: require('@/assets/coursetype/libu/banner.png'),
  videlUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/libu-all.mp4',
  type_name: '励步',
  type_des: '创新推出线上线下、同班同伴学习模式，以培养语言、跨学科应用能力和核心素养为目标，为孩子提供完整学习解决方案。'
}
export const contentBanner = {
  bg: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/content-bg.png',
  videlUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/content-all.mp4',
  type_name: '未来好课',
  type_des: '好未来18年教研教学经验沉淀的各学科教研资料和教学方法'
}
export const learningMachineBanner = {
  type_name: '彼芯学习机',
  bg: require('@/assets/pngs/banner-xuexiji.png'),
  videlUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/xuexiji_info.mp4',
  // type_des: '彼芯学习机是由好未来美校&魔法校联合打造的适合一年级~高三全学龄学生的智能学习机。使用华为C5平板作为系统载体，由好未来教研云核心团队提供课程内容，搭载了测评、拍搜、课本点读等智能学习工具'
}
export const technologyList = [
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-3-1.png',
    title: '解决方案',
    des: 'AI课堂方案、AI课堂守护系统、功课批改'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-3-2.png',
    title: '算法层',
    des: '语音技术、图像技术、NLP、视频理解'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-3-3.png',
    title: '数据层',
    des: '教学语音、手写试题、教学视频、功课题库'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-3-4.png',
    title: '硬件层',
    des: '线下课题AI硬件、云端XPU架构'
  }
]
export const aiLoveLearnList = [
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-4-1.png',
    des: '真实教学场景'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-4-2.png',
    des: '课中超过高频开口互动'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-4-3.png',
    des: '运用趣味动画，引入流行IP'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-4-4.png',
    des: 'AI智能判断学生学习状态'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-4-5.png',
    des: '课后阅读可听可练可读可玩'
  },
  {
    img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-4-6.png',
    des: '让孩子真正爱上学习'
  }
] 
export const contentCopSupList = [
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/content-3-1.png',
    main: '免费基础产品指导',
    des: '教育机构'
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/content-3-2.png',
    main: '产品使用深度培训',
    des: '深入机构'
  },
  {
    url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/content-3-3.png',
    main: '伴学方法系统培训',
    des: '做强机构'
  }
]
export const aboutUs = [
  {
    main: '关于未来魔法校',
    sub: '致力于成为全球优质科技教育产品供应平台',
    list: [
      {
        type: '1',
        img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/aboutUs/1-1.png',
        des: '未来魔法校基于好未来直营校全国办学实践经验，为K12校外培训机构提供双师课堂、AI教室、内容平台等解决方案，向行业输出北京主讲、优选外教、优质教研、教学工具、运营支持及系统服务，为合作机构解决教学、办学及信息化问题，助力其全面提升核心竞争力。'
      }
    ]
  },
  {
    main: '政府荣誉',
    sub: '好未来产品在影响力机构的获奖情况',
    list: [
      {
        type: '',
        img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/aboutUs/1-2.png',
        des: '2019年8月，工业和信息化部、中国互联网协会在2019年中国互联网企业100强发布会暨百强企业高峰论坛上联合发布2019年中国互联网企业100强榜单。好未来集团连续两年登上中国互联网百强榜单，同时也是今年榜单中唯一一家教育企业。'
      },
      {
        type: '',
        img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/aboutUs/1-3.png',
        des: '2019年11月，好未来荣登《2019中国人工智能企业知识产权竞争力百强榜》十强。'
      },
      {
        type: '',
        img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/aboutUs/1-4.png',
        des: '2019年11月，北京市工商联发布“2019北京民营企业百强”“2019北京民营企业科技创新百强”“2019北京民营企业文化产业百强”“2019北京民营企业社会责任百强”榜单。好未来旗下学而思入围全部四个百强榜单，位列文化产业百强第3位，位列社会责任百强第93位，位列科技创新百强第11位，位列民营企业百强第22位。'
      },
      {
        type: '',
        img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/aboutUs/1-5.png',
        des: '2019年11月27日，在2019“回响中国”腾讯新闻教育年度盛典上，未来魔法校荣获“2019年度影响力教育品牌”。'
      },
      {
        type: '',
        img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/aboutUs/1-6.png',
        des: '2019年12月4日，在第十届新华网教育论坛上，未来魔法校荣获“2019年度·公信力教育品牌”奖项。'
      },
      {
        type: '',
        img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/aboutUs/1-7.png',
        des: '2019年12月12日，在中国互联网新闻中心（中国网）主办，中国网教育频道承办的“中国好教育”年度教育盛典活动上，未来魔法校荣获“影响力教育品牌”奖项。'
      },
      {
        type: '',
        img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/aboutUs/1-8.png',
        des: '2020年4月，世界计算机视觉领域知名会议CVPR2020成功举办，好未来AI工程院从全球69支团队中脱颖而出，斩获EmotioNet人脸表情识别竞赛冠军。'
      },
      {
        type: '',
        img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/aboutUs/1-9.png',
        des: '2020年4月8日，联合国教科文组织授予好未来教育科技集团2020年度移动学习周“人工智能与包容性”创新示范项目证书，以表彰好未来集团在使用AI和大数据提高读写能力、保护(少数民族)语言并增进包容性方面的贡献。'
      },
      {
        type: '',
        img: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/aboutUs/1-10.png',
        des: '2020年4月14日，工信部公示了《疫情防控和复工复产复课大数据产品和解决方案名单》。作为教育领域的代表，好未来集团基于大数据的“停课不停学”在线教育解决方案榜上有名。'
      }
    ]
  }
]